import { render, staticRenderFns } from "./auth-callback.vue?vue&type=template&id=20a1674a&"
import script from "./auth-callback.vue?vue&type=script&lang=js&"
export * from "./auth-callback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports